module.exports = __webpack_public_path__ + "static/media/time-management.2556bef3.png";